import { render, staticRenderFns } from "./GlobalTrend.vue?vue&type=template&id=57713ac6&scoped=true"
import script from "./GlobalTrend.vue?vue&type=script&lang=js"
export * from "./GlobalTrend.vue?vue&type=script&lang=js"
import style0 from "./GlobalTrend.vue?vue&type=style&index=0&id=57713ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57713ac6",
  null
  
)

export default component.exports